import React, { useState } from "react";
import { Box, Chip, Typography } from "@mui/material";
import MyContainer from "../../../MyContainer";
import ArticleCard from "../../../ui/ArticleCard";
import { useBlogArticleGridSectionStyles } from "./BlogArticleGridSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import { useCommerceData } from "../../../../hooks/useCommerceData";
import { commerceRepository } from "../../../../api";

const BlogArticleGridSection = () => {
    const { classes } = useBlogArticleGridSectionStyles();
    const { t } = useI18n();
    const [category, setCategory] = useState<string | null>(null);

    const { data: categories } = useCommerceData(() => commerceRepository.getArticleCategories(), []);
    const { data } = useCommerceData(() => commerceRepository.getArticles({ category: category ?? undefined }), [category]);

    return (
        <MyContainer>
            <Box className={classes.filterRow}>
                <Chip
                    label={t("blogPage.allCategories")}
                    clickable
                    color={category === null ? "primary" : "default"}
                    variant={category === null ? "filled" : "outlined"}
                    onClick={() => setCategory(null)}
                />
                {categories?.map((cat) => (
                    <Chip
                        key={cat}
                        label={cat}
                        clickable
                        color={category === cat ? "primary" : "default"}
                        variant={category === cat ? "filled" : "outlined"}
                        onClick={() => setCategory(cat)}
                    />
                ))}
            </Box>

            {data?.items.length === 0 ? (
                <Typography className={classes.noResults}>{t("blogPage.noResults")}</Typography>
            ) : (
                <Box className={classes.grid}>
                    {data?.items.map((article) => (
                        <ArticleCard key={article.id} article={article} />
                    ))}
                </Box>
            )}
        </MyContainer>
    );
};

export default BlogArticleGridSection;
